import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { Pagination, PaginationItem } from '@material-ui/lab';
import { useStudentGoals } from 'sdk';

import GoalRow from 'pages/Teachers/StudentDetail/components/GoalRow';

import styles from './styles.module.scss';

const GoalsTable = ({ studentId, sectionId }) => {
  const history = useHistory();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const currentPage = '1';

  const itemsPerPage = 5;

  const currentOffset = (currentPage - 1) * itemsPerPage;

  const { data } = useStudentGoals({
    studentId,
    sectionId,
    limit: itemsPerPage,
    offset: currentOffset
  });

  const goals = data?.results || [];
  const totalCount = data?.count || 0;
  const totalPages = Math.ceil(totalCount / itemsPerPage);
  const isEmpty = goals.length === 0;

  const handlePageChange = (event, value) => {
    searchParams.set('section_page', value);
    history.push({
      pathname: location.pathname,
      search: searchParams.toString()
    });
  };

  return (
    <>
      <div className={styles.tableContainer}>
        <div className={styles.tableHeader}>
          <div className={styles.colGoal}>Goal</div>
          <div className={styles.colDate}>By Date</div>
          <div className={styles.colProgress}>Progress</div>
        </div>

        {isEmpty ? (
          <div className={styles.emptyStateContainer}>
            <p className={styles.emptyStateMessage}>
              No student goals found for this section.
            </p>
          </div>
        ) : (
          <div>
            {goals.map((goal) => (
              <GoalRow
                key={goal.id}
                title={goal.name}
                description={goal.description}
                standards={goal.standards}
                date={goal.due_date}
                progress={goal.progress_percentage}
                targetAccuracy={goal.target_accuracy}
              />
            ))}
          </div>
        )}
      </div>

      {totalPages > 1 && (
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePageChange}
          className={styles.pagination}
          renderItem={(item) => <PaginationItem {...item} disableRipple />}
        />
      )}
    </>
  );
};

export default GoalsTable;
